<div class="fi-dialog-wrapper">

  <!-- ── Dialog Header ─────────────────────────────────────────────────── -->
  <div class="fi-dialog-header">
    <div class="fi-header-left">
      <button
        *ngIf="mode !== 'LIST'"
        mat-icon-button
        class="fi-back-btn"
        (click)="goBack()"
        matTooltip="Back">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <img src="../../../../assets/icons/field_inspection_pin.png" alt="" class="fi-header-icon" />
      <span class="fi-header-title">Field Inspection Reports</span>
    </div>
    <button mat-icon-button class="fi-close-btn" (click)="requestClose()" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ── Resolving report (opened from tenant list) ───────────────────── -->
  <div *ngIf="resolvingReport" class="fi-mode-content flex items-center justify-center py-10">
    <span class="text-sm text-gray-400 italic">Loading inspection...</span>
  </div>

  <!-- ── Mode: LIST ────────────────────────────────────────────────────── -->
  <div *ngIf="!resolvingReport && mode === 'LIST'" class="fi-mode-content">
    <app-report-list
      [fieldId]="data.fieldId"
      [farmId]="data.farmId"
      [tenantId]="data.tenantId"
      [pinId]="data.pinId || null"
      [hidePinRequiredActions]="!data.pinId"
      (createNewInspection)="onCreateNewInspection()"
      (openExistingReport)="onOpenExistingReport($event)">
    </app-report-list>
  </div>

  <!-- ── Mode: NEW_INSPECTION (combined Crop + Inspector — matches mobile) -->
  <div *ngIf="mode === 'NEW_INSPECTION'" class="fi-mode-content fi-picker">

    <!-- Same element and classes as the step headings in the form, so the two match.
         A p rather than an h3: Tailwind is imported as layer(utilities) only, so
         Preflight never loads and a heading tag keeps the browser's default size. -->
    <p class="text-sm font-semibold text-gray-600 border-b pb-2 mb-4 uppercase tracking-wide">New Field Inspection</p>

    <!-- Loading crop definitions -->
    <div *ngIf="resolvingCropDefs" class="fi-loading">Loading field information...</div>

    <ng-container *ngIf="!resolvingCropDefs">

      <!-- Crop / Definition dropdown — only shown when multiple options exist -->
      <div *ngIf="data.cropDefinitions && data.cropDefinitions.length > 1" class="mb-4">
        <label class="block text-xs text-gray-500 mb-1">Crop / Definition</label>
        <select
          [(ngModel)]="selectedCropDefinitionId"
          class="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400">
          <option [ngValue]="null">— Select crop —</option>
          <option *ngFor="let def of data.cropDefinitions" [ngValue]="def.id">
            {{ def.label }}
          </option>
        </select>
      </div>

      <!-- Single crop — show as read-only label -->
      <div *ngIf="data.cropDefinitions && data.cropDefinitions.length === 1" class="mb-4">
        <label class="block text-xs text-gray-500 mb-1">Crop / Definition</label>
        <div class="border border-gray-200 rounded px-3 py-2 text-sm bg-gray-50 text-gray-700">
          {{ data.cropDefinitions[0].label }}
        </div>
      </div>

      <!-- Assign Inspector dropdown -->
      <div class="mb-6">
        <label class="block text-xs text-gray-500 mb-1">Assign Inspector</label>
        <div *ngIf="loadingInspectors" class="text-sm text-gray-400 italic py-2">Loading inspectors...</div>
        <select
          *ngIf="!loadingInspectors"
          [(ngModel)]="selectedInspectorId"
          class="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400">
          <option [ngValue]="null">— No inspector assigned —</option>
          <option *ngFor="let user of inspectors" [ngValue]="user.userId">
            {{ user.name }}
          </option>
        </select>
      </div>

      <!-- Actions -->
      <div class="fi-picker-actions">
        <button mat-stroked-button (click)="cancelNewInspection()">Cancel</button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="(data.cropDefinitions && data.cropDefinitions.length > 1 && !selectedCropDefinitionId) || loadingInspectors"
          (click)="startInspection()">
          Start Inspection
        </button>
      </div>

    </ng-container>
  </div>

  <!-- ── Mode: FORM ────────────────────────────────────────────────────── -->
  <div *ngIf="mode === 'FORM'" class="fi-mode-content fi-form-mode">
    <app-inspection-form
      [pinId]="data.pinId?.toString()"
      [fieldId]="data.fieldId"
      [tenantId]="data.tenantId"
      [seasonId]="data.seasonId"
      [lat]="data.lat"
      [lng]="data.lng"
      [viewOnly]="resolvedViewOnly"
      [reportId]="resolvedReportId"
      [inspectorUserId]="resolvedInspectorUserId"
      [cropDefinitionId]="resolvedCropDefinitionId"
      [crop]="resolvedCrop"
      [fieldType]="resolvedFieldType"
      (closeRequested)="requestClose()"
      (dirtyChange)="onFormDirtyChange($event)">
    </app-inspection-form>
  </div>

</div>
